import React, {JSX, useEffect, useState} from "react";
import "../styles/App.css";

import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";

import Home from "./pages/Home";
import ContactData from "./pages/ContactData";
import MedicalData from "./pages/MedicalData";
import EmergencyContacts from "./pages/EmergencyContacts";
import Groups from "./pages/Groups";
import Tours from "./pages/Tours";
import ShowPerson from "./pages/ShowPerson";
import Settings from "./pages/Settings";
import Sidebar from "./Sidebar";
import AccountData from "./pages/AccountData";

import {NAV, ROUTES} from "../constants/navigation";
import {useAccount} from "../hooks/AccountContext";
import {t} from "i18next";

interface MainPageProps {
    theme: string;
    setTheme: (value: string) => void;
}

function MainPage({theme, setTheme}: MainPageProps): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();

    const {account, logout, loading} = useAccount();   // 🔥 loading kommt jetzt dazu

    const [selected, setSelected] = useState<string>("home");

    useEffect(() => {
        const selectedKey = (
            Object.entries(ROUTES).find(([_, route]) => route === location.pathname)?.[0]
            ?? "HOME"
        ) as keyof typeof NAV;

        setSelected(NAV[selectedKey]);
    }, [location.pathname]);

    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const handleSidebarNavigate = (key: string, path: string) => {
        setSelected(key);
        navigate(path);
    };

    // // 🔥 WICHTIG: Während loading NICHT redirecten, NICHT rendern
    if (loading) {
        return (
            <div className="app-container">
                <Sidebar
                    selected={selected}
                    onNavigate={handleSidebarNavigate}
                    onLogout={handleLogout}
                />
                <div className="content loading-container">
                    <div className="spinner"/>
                    <h3>{t("common.messages.loading")}</h3>
                </div>
            </div>
        );
    }


    return (
        <div className="app-container">
            <Sidebar
                selected={selected}
                onNavigate={handleSidebarNavigate}
                onLogout={handleLogout}
            />

            <div className="content">
                <Routes>
                    <Route path="/" element={<Navigate to={ROUTES.HOME} replace/>}/>

                    <Route path={ROUTES.HOME} element={<Home/>}/>

                    <Route
                        path={ROUTES.ACCOUNT}
                        element={
                            account ? <AccountData/> : <Navigate to={ROUTES.HOME} replace/>
                        }
                    />

                    <Route
                        path={ROUTES.CONTACT}
                        element={
                            account ? <ContactData/> : <Navigate to={ROUTES.HOME} replace/>
                        }
                    />

                    <Route
                        path={ROUTES.MEDICAL}
                        element={
                            account ? <MedicalData/> : <Navigate to={ROUTES.HOME} replace/>
                        }
                    />

                    <Route
                        path={ROUTES.EMERGENCY}
                        element={
                            account ? <EmergencyContacts/> : <Navigate to={ROUTES.HOME} replace/>
                        }
                    />

                    <Route
                        path={ROUTES.GROUPS}
                        element={account ? <Groups/> : <Navigate to={ROUTES.HOME} replace/>}
                    />

                    <Route
                        path={ROUTES.TOURS}
                        element={account ? <Tours/> : <Navigate to={ROUTES.HOME} replace/>}
                    />

                    <Route path={ROUTES.SHOW_PERSON} element={<ShowPerson/>}/>

                    <Route
                        path={ROUTES.SETTINGS}
                        element={<Settings theme={theme} setTheme={setTheme}/>}
                    />
                </Routes>
            </div>
        </div>
    );
}

export default MainPage;